import "./components/i18n/I18n";
import { ToastContainer } from "react-toastify";

import "../node_modules/bootstrap/dist/css/bootstrap.css";

import "./assets/theme/Styles.scss";
import PublicRoutes from "./routes/PublicRoutes";
import { useEffect } from "react";
import { eventEmitter } from "./eventEmitters/EventEmitters";
import { disconnectSocket } from "./util/socket";
import { emptyLocalStorageOnLogout } from "./util/helper";
import { useDispatch } from "react-redux";
import ActionType from "./resources/enums";
import LoadTestToggle from "./components/loadTestToggle/LoadTestToggle";
import { toastMessageError } from "./components/utilities/commonToastMessage";

const App = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    logoutEvent();
  }, []);
  const logoutEvent = () => {
    // Session timeout redesign (2026-08-08) - this fires only on a genuine
    // 401 "unauthorized" from the backend (util/http.ts's response
    // interceptor), i.e. the session actually expired or was invalidated -
    // never for a transient socket drop, which TrafficIndicator already
    // surfaces ambiently without forcing a redirect. Distinct purpose from
    // that indicator: this is the one unambiguous "you WILL need to log
    // back in, here's why" moment, not a live-connection health signal.
    // Previously silent - a customer who left a tab open past the
    // absolute session cap would just land on the login screen with no
    // explanation, indistinguishable from a bug.
    eventEmitter.addListener("logout", () => {
      dispatch({
        type: ActionType.LOGOUT,
        payload: "",
      });
      disconnectSocket();
      emptyLocalStorageOnLogout();
      toastMessageError(
        "You've been signed out for security after an extended session. Please log back in.",
        "session-expired"
      );
    });
  };

  return (
    <div className="App">
      <PublicRoutes />
      <ToastContainer />
      <LoadTestToggle />
    </div>
  );
};

export default App;
